import { render, staticRenderFns } from "./RetailerProductCheckout.vue?vue&type=template&id=8bcfd7be&scoped=true"
import script from "./RetailerProductCheckout.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetailerProductCheckout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RetailerProductCheckout.vue?vue&type=style&index=0&id=8bcfd7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcfd7be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CBtnPrimary: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnPrimary/CBtnPrimary.vue').default,CBtnSecondary: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnSecondary/CBtnSecondary.vue').default})
